<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      ref="searchBox"
      permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  getSysStaticDataByCodeType,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        payStateOptions: [],
        stateOptions: [],
        vehicleClassOptions: [],
        form: [
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '缴费时间',
            value: 'payTime',
            type: 'date',
            placeholder: '缴费时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '业务单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入业务单号',
          },
          {
            label: '支付状态',
            value: 'payState',
            type: 'select',
            placeholder: '请选择支付状态',
            default: '-1',
          },
          {
            label: '批次号',
            value: 'soNbr',
            type: 'input',
            placeholder: '请输入批次号',
          },
          {
            label: '记录状态',
            value: 'state',
            type: 'select',
            placeholder: '请选择记录状态',
            default: '-1',
          },
          {
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            placeholder: '请选择车辆种类',
            default: '-1',
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.payTime && searchBoxData.payTime.length) {
        searchBoxData.startPayTime = this.formatDate(searchBoxData.payTime[0]);
        searchBoxData.endPayTime = this.formatDate(searchBoxData.payTime[1]);
      } else {
        searchBoxData.startPayTime = '';
        searchBoxData.endPayTime = '';
      }
      delete searchBoxData.payTime;
      this.$refs.tableBox.getFromValue(searchBoxData);
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const stateOptions = await getSysStaticDataByCodeType({
      codeType: 'SYS_STATE_DESC',
    });
    const vehicleClassOptions = await getSysStaticDataByCodeType({
      codeType: 'VEHICLE_CLASS',
    });
    const payStateOptions = await getSysStaticDataByCodeType({
      codeType: 'PAY_TYPE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...stateOptions,
    ];
    this.searchBoxData.vehicleClassOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...vehicleClassOptions,
    ];
    this.searchBoxData.payStateOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...payStateOptions,
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
